import type Phaser from 'phaser';
import type { AudioKey } from '../registry/keys';
import * as synth from './synth';

/**
 * Thin SFX/music facade. Audio is procedural (see synth.ts) — the keyed slots
 * stay (drop real CC0 files + register in assetManifest later to swap), but
 * today they map straight to synthesized blips. All gated behind the title tap.
 */

/** Grab Phaser's (unlocked) WebAudio context for the synth. Call on first tap. */
export function initAudio(scene: Phaser.Scene): void {
  const mgr = scene.sound as Phaser.Sound.WebAudioSoundManager;
  if (mgr && mgr.context) synth.initAudio(mgr.context);
}

export function playSfx(_scene: Phaser.Scene, key: AudioKey, _volume = 0.6): void {
  synth.play(key.replace(/^au_/, ''));
}

export function startMusic(_scene?: Phaser.Scene): void {
  synth.startMusic();
}

export function setMuted(muted: boolean): void {
  synth.setMuted(muted);
}

export const setSfxEnabled = (b: boolean): void => synth.setSfxEnabled(b);
export const setMusicEnabled = (b: boolean): void => synth.setMusicEnabled(b);
export const isSfxEnabled = (): boolean => synth.isSfxEnabled();
export const isMusicEnabled = (): boolean => synth.isMusicEnabled();
export const setSeason = (id: string): void => synth.setSeason(id);
export const setRain = (on: boolean): void => synth.setRain(on);
export const setFestival = (on: boolean): void => synth.setFestival(on);
